const steps = [
  { num: "1", title: "Store secrets", desc: "Add API keys, tokens, and credentials to your vault." },
  { num: "2", title: "Get an API key", desc: "Generate a scoped key for each agent or workflow." },
  { num: "3", title: "Give your agent a skill", desc: "OpenClaw or any agent calls passkeep on demand to fetch what it needs." },
];

export function HowItWorks() {
  return (
    <div className="relative z-20 px-6 pb-24 md:px-[120px]">
      <div className="mx-auto flex max-w-3xl flex-col gap-6 sm:flex-row sm:gap-8">
        {steps.map((s) => (
          <div key={s.num} className="flex-1">
            <span
              className="font-medium text-white/30"
              style={{ fontSize: "13px" }}
            >
              {s.num}
            </span>
            <p className="mt-2 text-sm font-medium text-white">{s.title}</p>
            <p className="mt-1 text-sm text-white/50">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
